"use client";
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LampContainer } from "./lamp";

export function HudsonLampDemo() {
  return (
    <LampContainer className="bg-slate-950">
      <motion.div
        initial={{ opacity: 0.5, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.3,
          duration: 0.8,
          ease: "easeInOut",
        }}
        className="text-center"
      >
        <motion.p
          initial={{ opacity: 0.3 }}
          whileInView={{ opacity: 0.8 }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="mb-4 text-lg font-medium text-slate-400 tracking-wide"
        >
          We Maintain Your Home So You Don&apos;t Have To.
        </motion.p>
        
        <motion.h1
          className="mt-4 bg-gradient-to-br from-slate-200 to-slate-400 py-4 bg-clip-text text-center text-4xl font-bold tracking-tight text-transparent md:text-7xl"
        >
          The Hudson Club™
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 0.9 }}
          transition={{ delay: 0.7, duration: 0.8 }}
          className="mt-6 text-xl text-slate-300 max-w-2xl mx-auto leading-relaxed"
        >
          A private membership for discerning homeowners who want every detail managed — 
          before they even think of it.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.0, duration: 0.6 }}
          className="mt-8 flex flex-col sm:flex-row gap-4 justify-center items-center"
        >
          <Link to="/membership" className="bg-cyan-500 hover:bg-cyan-400 text-white px-8 py-3 rounded-lg font-medium transition-colors inline-block">
            Discover Home Membership
          </Link>
          <button className="border border-slate-400 text-slate-300 hover:text-white hover:border-white px-8 py-3 rounded-lg font-medium transition-colors">
            Request Invitation
          </button>
        </motion.div>
      </motion.div>
    </LampContainer>
  );
} 